import { Box } from "@mui/material";
import { formatDate } from "../../../../../../../../../utils/date-time-utility";
import Text from "../../../../../../../../../components/Text";
import {
  DEFAULT_BG_COLOR,
  DEFAULT_KEY_LABEL_COLOR,
  DEFAULT_LABEL_COLOR,
  replaceUnderScoreAddSpace,
} from "../../../../../../../../../utils/utils";
import {
  VACCINE_ROUTE_MAPPER,
  VACCINE_SITE_MAPPER,
} from "../../../clinical-details/components/ClinicalLayout-constant";

const VaccineRow: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "110px 8px 1fr",
      alignItems: "start",
    }}
  >
    <Text sx={{ color: DEFAULT_KEY_LABEL_COLOR }}>{label}</Text>
    <Text sx={{ color: DEFAULT_KEY_LABEL_COLOR }}>:</Text>
    <Text sx={{ color: "#222", wordBreak: "break-word" }}>{value}</Text>
  </Box>
);

interface VaccinesData {
  vaccine: any;
  uuid: string;
  patient: Record<string, string>;
  administerDate: string;
  administeredBy: Record<string, string>;
  manufacturer: string;
  lot: string;
  dose: string;
  units: string;
  route: string;
  site: string;
  expiryDate: string;
  doseDuration: number;
  vaccineType: string;
  note: string;
  active: boolean;
  archive: boolean;
  recordedDate: Date;
}

export const VaccinesTooltip: React.FC<{ data: VaccinesData }> = ({ data }) => (
  <Box sx={{ minWidth: 250 }}>
    {/* Title Bar */}
    <Box
      sx={{
        background: DEFAULT_BG_COLOR,
        padding: "8px 12px",
      }}
    >
      <Text color={DEFAULT_LABEL_COLOR}>Vaccines Details</Text>
    </Box>
    {/* Content */}
    <Box
      sx={{
        padding: "12px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <VaccineRow label="Vaccine Name" value={data?.vaccine?.name} />
      <VaccineRow
        label="Dose Duration"
        value={data?.doseDuration?.toString()}
      />
      <VaccineRow
        label="Vaccine Type"
        value={
          data?.vaccineType ? replaceUnderScoreAddSpace(data?.vaccineType) : ""
        }
      />
      <VaccineRow
        label="Administer Date"
        value={data?.administerDate ? formatDate(data?.administerDate) : ""}
      />
      <VaccineRow
        label="Administered By"
        value={
          data?.administeredBy ? Object.values(data?.administeredBy)?.[0] : ""
        }
      />
      <VaccineRow
        label="Expiry Date"
        value={data?.expiryDate ? formatDate(data?.expiryDate) : ""}
      />
      <VaccineRow
        label="Amount"
        value={
          data?.dose
            ? `${data?.dose} ${data?.units ? replaceUnderScoreAddSpace(data?.units?.toLowerCase()) : ""}`
            : ""
        }
      />
      <VaccineRow
        label="Route"
        value={VACCINE_ROUTE_MAPPER[data?.route] ?? ""}
      />
      <VaccineRow label="Site" value={VACCINE_SITE_MAPPER[data?.site] ?? ""} />
      <VaccineRow label="Manufacturer" value={data?.manufacturer} />
      <VaccineRow label="Lot Number" value={data?.lot} />
    </Box>
  </Box>
);
